export default __webpack_public_path__ + "static/media/Recognition.3b10b824.png";